/** Gerado por scripts/sync-deploy-revision.mjs — não editar manualmente. */
export const DEPLOY_REVISION = '07d0107a09d59e6ea413f80bbc962455c6fc1bfa' as const;
